import { IUser, User } from '@/shared/model/user.model';
import { IDiscount } from '@/shared/model/discount.model';
import { Address, IAddress } from '@/shared/model/address.model';
import { IRating } from '@/shared/model/rating.model';
import { IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IRestaurantWorkingTimes } from '@/shared/model/restaurant-working-times.model';
import { IMenuCategory } from '@/shared/model/menu-category.model';
import { IMessage } from '@/shared/model/message.model';
import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';
import { ICustomer } from '@/shared/model/customer.model';
import { IMarketer } from '@/shared/model/marketer.model';
import { IRatingSummary } from './rating-summary.model';

export interface IRestaurant {
  id?: number;
  name?: string | null;
  logoContentType?: string | null;
  logo?: string | null;
  logoPath?: string | null;
  imageContentType?: string | null;
  image?: string | null;
  imagePath?: string | null;
  registerNumber?: string | null;
  taxIdentificationNumber?: string | null;
  deliver?: boolean | false;
  pickup?: boolean | false;
  bankAccountName?: string | null;
  ibanNumber?: string | null;
  enabled?: boolean | false;
  completed?: boolean | false;
  approved?: boolean | false;
  released?: boolean | false;
  finished?: boolean | false;
  updated?: boolean | false;
  menuCardUpdate?: boolean | false;
  startingDate?: Date | null;
  domain?: boolean | false;
  menuCard?: string[] | null;
  menuCardContentType?: string | null;
  menuCardPath?: string | null;
  idCard?: string[] | null;
  idCardContentType?: string | null;
  idCardPath?: string | null;
  cocRegistration?: string[] | null;
  cocRegistrationContentType?: string | null;
  cocRegistrationPath?: string | null;
  bankCard?: string[] | null;
  bankCardContentType?: string | null;
  bankCardPath?: string | null;
  newsletter?: boolean | false;
  user?: IUser | null;
  foodDiscount?: IDiscount | null;
  foodDiscountValue?: number | null;
  nonfoodDiscount?: IDiscount | null;
  nonfoodDiscountValue?: number | null;
  address?: IAddress | null;
  ratings?: IRating[] | null;
  ratingSummary?: IRatingSummary | null;
  deliverySpecs?: IDeliverySpec[] | null;
  deliverySpec?: IDeliverySpec | null;
  restaurantWorkingTimes?: IRestaurantWorkingTimes[] | null;
  menuCategories?: IMenuCategory[] | null;
  messages?: IMessage[] | null;
  restaurantCategories?: IRestaurantCategory[] | null;
  customer?: ICustomer | null;
  marketer?: IMarketer | null;
  dateOfBirth?: Date | null;
  startingDateString?: string | null;
  currentWorkingTimes?: IRestaurantWorkingTimes | null;
  stripeActivated?: boolean | false;
  stripeId?: string | null;
  stripeOnboardLink?: string | null;
}

export class Restaurant implements IRestaurant {
  constructor(
    public id?: number,
    public name?: string | null,
    public logoContentType?: string | null,
    public logo?: string | null,
    public logoPath?: string | null,
    public imageContentType?: string | null,
    public image?: string | null,
    public imagePath?: string | null,
    public registerNumber?: string | null,
    public taxIdentificationNumber?: string | null,
    public deliver?: boolean | false,
    public pickup?: boolean | false,
    public bankAccountName?: string | null,
    public ibanNumber?: string | null,
    public enabled?: boolean | false,
    public completed?: boolean | false,
    public approved?: boolean | false,
    public released?: boolean | false,
    public updated?: boolean | false,
    public finished?: boolean | false,
    public menuCardUpdate?: boolean | false,
    public startingDate?: Date | null,
    public domain?: boolean | false,
    public menuCard?: string[] | null,
    public menuCardContentType?: string | null,
    public menuCardPath?: string | null,
    public idCard?: string[] | null,
    public idCardContentType?: string | null,
    public idCardPath?: string | null,
    public cocRegistration?: string[] | null,
    public cocRegistrationContentType?: string | null,
    public cocRegistrationPath?: string | null,
    public bankCard?: string[] | null,
    public bankCardContentType?: string | null,
    public bankCardPath?: string | null,
    public newsletter?: boolean | false,
    public user?: IUser | null,
    public foodDiscount?: IDiscount | null,
    public foodDiscountValue?: number | null,
    public nonfoodDiscount?: IDiscount | null,
    public nonfoodDiscountValue?: number | null,
    public address?: IAddress | null,
    public ratings?: IRating[] | null,
    public ratingSummary?: IRatingSummary | null,
    public deliverySpecs?: IDeliverySpec[] | null,
    public deliverySpec?: IDeliverySpec | null,
    public restaurantWorkingTimes?: IRestaurantWorkingTimes[] | null,
    public menuCategories?: IMenuCategory[] | null,
    public messages?: IMessage[] | null,
    public restaurantCategories?: IRestaurantCategory[] | null,
    public customer?: ICustomer | null,
    public marketer?: IMarketer | null,
    public dateOfBirth?: Date | null,
    public currentWorkingTimes?: IRestaurantWorkingTimes | null,
    public stripeActivated?: null | false,
    public stripeId?: string | null,
    public stripeOnboardLink?: string | null
  ) {
    this.deliver = this.deliver ?? false;
    this.pickup = this.pickup ?? false;
    this.enabled = this.enabled ?? true;
    this.completed = this.completed ?? false;
    this.approved = this.approved ?? false;
    this.released = this.released ?? false;
    this.updated = this.updated ?? false;
    this.menuCardUpdate = this.menuCardUpdate ?? false;
    this.domain = this.domain ?? false;
    this.newsletter = this.newsletter ?? false;
    this.startingDate = this.startingDate ?? new Date();
    this.address = this.address ?? new Address();
    this.user = this.user ?? new User();
    this.stripeActivated = this.stripeActivated ?? false;
  }

  public get startingDateString(): string {
    return this.startingDate.toISOString().substr(0, 10);
  }

  public set startingDateString(newStartingDate: string) {
    this.startingDate = new Date(newStartingDate);
  }
}
